import { Actions, State, ActionType } from './types';
import {
  remoteResourceInitialState,
  remoteResourceLoadFailure,
  remoteResourceLoading,
  remoteResourceLoadSuccess,
  getDateValue,
} from '../../helpers';

const initialState: State = {
  filters: {
    country: '',
    accountingMonth: getDateValue(null),
    status: null,
  },
  monthClosing: remoteResourceInitialState([]),
  annul: undefined,
};

const reducer = (state: State = initialState, action: Actions): State => {
  switch (action.type) {
    case ActionType.monthClosingChangeFilterCountry:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...{
            country: action.country,
          },
        },
      };
    case ActionType.monthClosingChangeFilterAccountingMonth:
      return {
        ...state,
        filters: {
          ...state.filters,
          accountingMonth: getDateValue(action.accountingMonth),
        },
      };
    case ActionType.monthClosingChangeFilterStatus:
      return {
        ...state,
        filters: {
          ...state.filters,
          status: action.status,
        },
      };
    case ActionType.monthClosingFindRequested:
      return {
        ...state,
        monthClosing: remoteResourceLoading([]),
      };
    case ActionType.monthClosingFindSuccess:
      return {
        ...state,
        monthClosing: remoteResourceLoadSuccess(action.monthClosing),
      };
    case ActionType.monthClosingFindFailure:
      return {
        ...state,
        monthClosing: remoteResourceLoadFailure([], action.error),
      };
    case ActionType.monthClosingChangeAnnul:
      return {
        ...state,
        annul: action.monthClosing,
      };
    default:
      return state;
  }
};

export default reducer;
